import { render } from "./ComponentePerfilesPPA.vue?vue&type=template&id=e9696242"
import script from "./ComponentePerfilesPPA.vue?vue&type=script&lang=js"
export * from "./ComponentePerfilesPPA.vue?vue&type=script&lang=js"

import "./ComponentePerfilesPPA.vue?vue&type=style&index=0&id=e9696242&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__